import React, { useState, useRef } from 'react';

import { useLanguage } from '../../Contexts/LanguageContext';
import './IntroVideo.scss';

const IntroVideo = () => {
  const videoRef = useRef(null);
  const overlayRef = useRef(null);

  const { getLanguageData } = useLanguage();
const data = getLanguageData();

  const introVideoTitle = data.atpSection.introVideoTitle;

  const handlePlay = () => {
    const video = videoRef.current;
    const overlay = overlayRef.current;
    if (video.paused) {
      video.play();
      overlay.style.display = 'none';
      video.controls = true; // Show controls when video starts playing
    } else {
      video.pause();
      overlay.style.display = 'block';
      video.controls = false; // Hide controls when video pauses
    }
  };

  const handleVideoPlay = () => {
    const video = videoRef.current;
    video.controls = true; // Show controls when video starts playing
    const overlay = overlayRef.current;
    overlay.style.display = 'none'; // Hide overlay when video starts playing
  };

  const handleVideoPause = () => {
    const video = videoRef.current;
    video.controls = false; // Hide controls when video pauses
    const overlay = overlayRef.current;
    overlay.style.display = 'block'; // Show overlay when video pauses
  };

  return (
    <div className={`atp-video-container`}>
      <video
        controls
        id="atpVideo"
        loop
        muted
        playsInline
        poster="/Assets/images/poster.png"
        ref={videoRef}
        onClick={handlePlay}
        onPlay={handleVideoPlay}
        onPause={handleVideoPause}
      >
        <source src="/Assets/videos/app-demo-walkthrough.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="overlay" ref={overlayRef}>
        <div className='video-title'>{introVideoTitle}</div>
        <button className={`custom-play-button`} onClick={handlePlay}>
          <img src="/Assets/images/play-icon.svg" alt="Play" />
        </button>
      </div>        
    </div>
  );
};

export default IntroVideo;
